import React from "react";
import {
    Alert, AppBar, Box, Button, CircularProgress, Dialog, DialogContent, IconButton, Stack, Toolbar, Tooltip, Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

// Un reporte en pantalla completa, armado en HTML con los mismos datos del PDF, y el botón para bajar el PDF.
const ReportViewerDialog = ({
    open, onClose, title, subtitle, Preview, data, loading = false, error = null, onDownload, downloading = false, downloadError = null,
}) => (
    <Dialog fullScreen open={open} onClose={onClose}>
        <AppBar position="sticky" color="inherit" elevation={0} sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Toolbar sx={{ gap: 1.5 }}>
                <Tooltip title="Cerrar">
                    <IconButton edge="start" onClick={onClose}><CloseIcon /></IconButton>
                </Tooltip>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="h5" noWrap>{title}</Typography>
                    {!!subtitle && <Typography variant="caption" color="text.secondary" noWrap component="div">{subtitle}</Typography>}
                </Box>
                <Button variant="contained" disabled={downloading} onClick={onDownload} sx={{ flexShrink: 0 }}
                        startIcon={downloading ? <CircularProgress size={16} color="inherit" /> : <FileDownloadOutlinedIcon />}>
                    Descargar PDF
                </Button>
            </Toolbar>
        </AppBar>
        <DialogContent sx={{ bgcolor: "background.default", p: { xs: 2, md: 3 } }}>
            <Stack spacing={2}>
                {downloading && <Typography variant="caption" color="text.secondary">Generando el PDF… también quedará en Descargas.</Typography>}
                {!!downloadError && <Alert severity="error">{downloadError}</Alert>}
                {!!error && <Alert severity="error">{error}</Alert>}
                {loading && <Box sx={{ py: 6, textAlign: "center" }}><CircularProgress /></Box>}
                {!loading && !!data && Preview && <Preview data={data} />}
            </Stack>
        </DialogContent>
    </Dialog>
);

export default ReportViewerDialog;
